// extracted by mini-css-extract-plugin
export default {"btn":"LogoutBtn_btn__TITsM","icon":"LogoutBtn_icon__WL2-F"};